<boi-contextual-help-container [ngClass]="{'has-errors': hasError}"
    [contextualHelpName]="contextualHelpName !== undefined ? contextualHelpName : labelName">
    <boi-validation-error (errorChange)="hasError=$event" [propertyNames]="propertyNames"></boi-validation-error>
    <kendo-textbox-container class="form-element app align-items-center">
        <div class="form-label app" [boiRequiredFormField]="labelName" [forceNotRequired]="forceNotRequired">
            <label [for]="controlId ? controlId : labelName" [innerHtml]="labelName |
                        localizeLabel"></label>
        </div>
        <div class="form-input-container">
            <div>
                <kendo-dropdownlist
                    [data]="optionList ? (optionList | localizeOptionList) : availableOptions"
                    [valuePrimitive]="true" [textField]="textField" id="controlId ? controlId : labelName"
                    [valueField]="valueField" [(ngModel)]="value"
                    [disabled]="isFieldDisabled" [ngClass]="{'disabled': isFieldDisabled}"
                    [defaultItem]="defaultItem" [virtual]="isVirtualizationEnable?virtualizationSettings:undefined"
                    (ngModelChange)="valueChange.emit(value)"
                    [popupSettings]="{ animate: false, appendTo: 'component' }">
                </kendo-dropdownlist>
            </div>
        </div>

        <boi-tooltip [tooltipName]="tooltipName ? tooltipName : labelName"></boi-tooltip>

    </kendo-textbox-container>
</boi-contextual-help-container>

